// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__32ZzW","col":"styles_col__3miUm"};